<template>
    <propertyPop ref="pop" type="map" v-ga:pop="{pageType: 'vdppmap', glb: glb, state: dpp}">
        <template v-slot:header>
            <div>
                <div class="f6 flex left property-pop-buttons" >
                    <button v-if="streetViewAvailable" type="button"  :aria-label="!$refs.mapRef?.hasActiveStreetView ? 'Street View' : 'Map View'" class="link" @click="() => toggleStreetView()">
                        <i :class="!$refs.mapRef?.hasActiveStreetView? 'icon-streetview' : 'icon-map'"></i>
                        <span>{{!$refs.mapRef?.hasActiveStreetView ? 'Street View' : 'Map View'}}</span>
                    </button>
                    <button type="button"  class="link" @click="directTo">
                        <i class="icon-arrow-curve-up-right"></i>
                        <span>Directions</span>
                    </button>
                </div>
            </div>
        </template>
        <template v-slot:body>
            <div class="property-popmap">
                <mvtNewMap
                  ref="mapRef"
                  :listings="nearbyHomes"
                  :pois="filteredPois"
                  :zoomControl="!glb.isMobile"
                  class="property-popmap__map"
                  :popMapTypeId="popMapTypeId"
                  @ready="onMapReady"
                >
                <template #default="slotProps">
                  <CustomControl position="TOP_RIGHT">
                    <div class="p-y-2 p-x-2">
                      <mvtMapOptionsPanel
                          :changeMapLayer="slotProps.changeMapLayer"
                          :changeMapType="slotProps.changeMapType"
                          :activeLayer="slotProps.activeLayer"
                          :activeMapType="slotProps.activeMapType"
                      />
                    </div>
                  </CustomControl>
                </template>
              </mvtNewMap>
            </div>
        </template>
    </propertyPop>
</template>
<script src="./property-popmap.js"></script>

<style lang="scss">
@use "./property-popmap.scss" as *;
</style>
